import router from '@/router';
import { Inputs, validationSchema } from '@/entities/BettingCompanies/BettingCompaniesFormInputs';
import { Endpoints } from '@/api/ApiEndpoints';

const BettingCompanies = {
	Plural: 'Betting Companies',
	Single: 'Betting Company',
	IsPage: true,
	FormWithImage: true,
	Inputs: Inputs,
	Relationships: [
		{
			name: 'countryIds',
			endpoint: Endpoints.COUNTRIES_FOR_FILTERS,
			mapping: (response) => {
				return response;
			},
		},
		{
			name: 'excludeCountryIds',
			endpoint: Endpoints.COUNTRIES_FOR_FILTERS,
			mapping: (response) => {
				return response;
			},
		},
	],
	ValidationSchema: validationSchema,
	SaveCallBack: (id) => {
		router.push(`/betting-companies/edit/${id}`);
	},
};

export default BettingCompanies;
